var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ComponentFactoryResolver, ComponentRef, ElementRef, Injector, } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { config } from '../../../../config/config';
import { ModalService } from '../../../common/services/modal.service';
import { HubPlace, PlaceBusinessStatus } from '../../../models/hub/hub.place';
import { HubApiService } from '../../../services/hub.api.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { PlaceService } from '../../../services/place.service';
import { EditPlaceImagesModalComponent } from '../edit.place.images.modal/edit.place.images.modal.component';
import { EditPlaceImagesModalActions } from '../edit.place.images.modal/edit.place.images.modal.provider';
import { ShowInfoModalComponent } from '../show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions } from '../show.info.modal/show.info.modal.provider';
import { EditPlaceModalActions } from './edit.place.modal.provider';
import { AlertifyService } from '../../../services/alertify.service';
import { EditPlaceCategoryModalComponent } from '../edit.place.category.modal/edit.place.category.modal.component';
import { EditPlaceCategoryModalActions } from '../edit.place.category.modal/edit.place.category.modal.provider';
import { LocalStorageService } from '../../../services/localStorageService';
import { BulkAIDescriptionsModalComponent } from '../bulk.ai.descriptions.modal/bulk.ai.descriptions.modal.component';
import { BulkAIDescriptionsStore, ToggleStore } from '../../../stores/hub.calendar.store';
import * as jwt_decode from 'jwt-decode';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { EditManuallyPlaceImagesModalActions } from '../edit.manually.place.images.modal/edit.manually.place.images.modal.provider';
import { EditManuallyPlaceImagesModalComponent } from '../edit.manually.place.images.modal/edit.manually.place.images.modal.component';
var EditPlaceModalComponent = /** @class */ (function (_super) {
    __extends(EditPlaceModalComponent, _super);
    //@ViewChild('descriptionTextarea') public descriptionTextarea: ElementRef;
    function EditPlaceModalComponent(dialogRef, actions, hubApiService, imageService, alertify, modalService, togglesStore, formBuilder, bulkAIDescriptionsStore, componentFactoryResolver, injector, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.hubApiService = hubApiService;
        _this.imageService = imageService;
        _this.alertify = alertify;
        _this.modalService = modalService;
        _this.togglesStore = togglesStore;
        _this.formBuilder = formBuilder;
        _this.bulkAIDescriptionsStore = bulkAIDescriptionsStore;
        _this.componentFactoryResolver = componentFactoryResolver;
        _this.injector = injector;
        // public initialTopCategoryList = [];
        // public categoryList = [];
        _this.subCategories = [];
        _this.isUploadImage = false;
        _this.showEditGoogleImagesBtn = false;
        _this.isImageChanged = false;
        _this.hasCopyrights = false;
        _this.hasServes = false;
        _this.sizeLimit = config.eventImageSizeLimit;
        _this.lockTip = "Currently Unlocked (default/recommended):  Locking will prevent this field from being updated on future automated refreshes.";
        _this.isDescriptionNeedShowMore = false;
        _this.isGeneratingDescription = false;
        _this.aiGeneratedDescription = [];
        _this.place = Object.assign({}, data);
        if (!_this.place.audio) {
            _this.place.audio = { isActive: false, link: '', description: '' };
        }
        _this.createForm();
        // this.isUploadImage = imageService.isImUploadedImage(imageService.imageSource(this.place));
        _this.selectedImageData = _this.isUploadImage ? imageService.imageSource(_this.place) : null;
        _this.imageLink = !_this.isUploadImage ? imageService.imageSource(_this.place) : null;
        _this.showEditGoogleImagesBtn = _this.place.socialName === 'google';
        _this.togglesStore.toggleCommand
            .takeUntil(_this.isDestroyed)
            .subscribe(function (toggleCommand) {
            _this.toggles = toggleCommand;
        });
        _this.imageWayChange();
        _this.place.categoryText = PlaceService.allToReadableCategory(_this.place.category);
        _this.descriptionChange();
        _this.setUpHtmlEditor();
        return _this;
    }
    EditPlaceModalComponent.prototype.showEditImagesModal = function () {
        var _this = this;
        if (this.place.isManuallyCreated) {
            var actions = {
                confirm: function (event, place, coverImg) {
                    _this.place = place;
                    _this.imageLink = coverImg;
                },
            };
            this.modalService.show({
                component: EditManuallyPlaceImagesModalComponent,
                providers: [
                    { provide: EditManuallyPlaceImagesModalActions, useValue: actions },
                    { provide: HubPlace, useValue: this.place },
                ],
                panelClass: ['width-modal-50p', 'min-width-800px'],
            });
        }
        else {
            var actions = {
                confirm: function (event, place, coverImg) {
                    _this.place = place;
                    // take the cover image and it will be uploaded to AWS in the confirm function
                    _this.imageLink = coverImg;
                },
            };
            this.modalService.show({
                component: EditPlaceImagesModalComponent,
                providers: [
                    { provide: EditPlaceImagesModalActions, useValue: actions },
                    { provide: HubPlace, useValue: this.place },
                ],
                panelClass: ['width-modal-50p', 'min-width-800px'],
            });
        }
    };
    EditPlaceModalComponent.prototype.showEditCategoryModal = function () {
        var _this = this;
        var actions = {
            confirm: function (event, category) {
                _this.place.category = category.category;
                _this.place.categoryList = category.categoryList;
                _this.place.categoryText = category.categoryText;
            },
        };
        this.modalService.show({
            component: EditPlaceCategoryModalComponent,
            providers: [
                { provide: EditPlaceCategoryModalActions, useValue: actions },
                { provide: HubPlace, useValue: this.place },
            ],
            panelClass: 'width-modal-70p',
        });
    };
    EditPlaceModalComponent.prototype.imageWayChange = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.isUploadImage) {
                if (_this.mask) {
                    _this.mask.nativeElement.style.height = '40px';
                    _this.mask.nativeElement.style.cursor = 'pointer';
                    _this.mask.nativeElement.style.backgroundColor = 'black';
                }
                if (_this.upload) {
                    _this.upload.nativeElement.style.cursor = 'pointer';
                    _this.upload.nativeElement.style.backgroundColor = '#D3D0D0';
                }
            }
            else {
                if (_this.mask) {
                    _this.mask.nativeElement.style.height = _this.imgEle.nativeElement.height + 'px';
                    _this.mask.nativeElement.style.cursor = 'default';
                    _this.mask.nativeElement.style.backgroundColor = 'gray';
                }
                if (_this.upload) {
                    _this.upload.nativeElement.style.cursor = 'default';
                    _this.upload.nativeElement.style.backgroundColor = '#ececec';
                }
            }
        });
    };
    // public categoryChanged() {
    //     this.place.categoryList = [];
    //     this.categoryList.forEach(x => {
    //         if (this.initialTopCategoryList[x]) {
    //             this.place.categoryList.push(...this.initialTopCategoryList[x]);
    //         } else {
    //             this.place.categoryList.push(x);
    //         }
    //     });
    //     this.place.category = this.place.categoryList.join(', ');
    //     this.place.categoryText = this.place.categoryList.map((x => x.replace(/(_)+/g, " ").upperFirstLetter())).join(', ');
    //     console.log(this.place.category);
    // }
    EditPlaceModalComponent.prototype.onImageChange = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var reader, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.selectedImageFile = $event.srcElement.files[0];
                        if (!!!this.selectedImageFile) return [3 /*break*/, 2];
                        reader = new FileReader();
                        reader.onload = function (e) {
                            _this.selectedImageData = e.target['result'];
                            _this.imageWayChange();
                        };
                        reader.readAsDataURL(this.selectedImageFile);
                        _a = this;
                        return [4 /*yield*/, this.imageService.compressImageFile(this.selectedImageFile)];
                    case 1:
                        _a.selectedImageFile = _b.sent();
                        // } else {
                        //     window.alert('This image is too large!');
                        //     this.imageSelector.nativeElement.value = '';
                        // }
                        this.isImageChanged = true;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    EditPlaceModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    EditPlaceModalComponent.prototype.toggleAudioTour = function () {
        this.place.audio.isActive = !this.place.audio.isActive;
    };
    Object.defineProperty(EditPlaceModalComponent.prototype, "isValid", {
        get: function () {
            //return !!(this.isUploadImage ? this.selectedImageFile : this.imageLink);
            return this.place.name && this.place.address;
        },
        enumerable: true,
        configurable: true
    });
    EditPlaceModalComponent.prototype.confirm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var allSettings;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(this.place.lock);
                        if (this.place.youtubeLink && this.place.youtubeLink.indexOf('/watch?v=') < 0) {
                            this.alertify.warning('Please specify a correct Youtube video link.');
                            event.complete();
                            return [2 /*return*/];
                        }
                        if (!this.place.category) {
                            event.complete();
                            this.alertify.warning('Please specify a category.');
                            return [2 /*return*/];
                        }
                        if (this.place.audio.isActive) {
                            if (!this.place.audio.link) {
                                event.complete();
                                this.alertify.warning('Please add audio tour link.');
                                return [2 /*return*/];
                            }
                            else {
                                if (!this.isAudioUrl(this.place.audio.link)) {
                                    event.complete();
                                    this.alertify.warning('The audio tour link is not an audio file link.');
                                    return [2 /*return*/];
                                }
                            }
                        }
                        if (!this.place.audio.isActive && this.place.audio.link) {
                            this.place.audio.link = null;
                            this.place.audio.description = null;
                        }
                        this.place.title = this.place.name;
                        return [4 /*yield*/, this.processImage()];
                    case 1:
                        _a.sent();
                        this.processLinks();
                        this.place.description = this.descriptionEditor.getContents();
                        //Need research why wangEditor get default value is "<p><br></p>" when empty
                        // if(this.place.description === "<p><br></p>"){
                        //   this.place.description = "";
                        // }
                        // for CLOSED_PERMANENTLY places, set to unapproved
                        if (this.place.business_status === PlaceBusinessStatus.CLOSED_PERMANENTLY) {
                            this.place.isApproved = false;
                        }
                        else if (this.place.business_status === PlaceBusinessStatus.CLOSED_TEMPORARILY) {
                            allSettings = LocalStorageService.getAllBackendSettingsFromLocalStorage();
                            if (allSettings && allSettings.customSettings.isKeepTempClosedPlaceInApproved === false) {
                                this.place.isApproved = false;
                            }
                        }
                        this.hubApiService
                            .updatePlace(this.place.hubName, this.place._id, this.place)
                            .subscribe(function (image) {
                            if (image) {
                                if (!_this.place.cover) {
                                    _this.place.cover = { source: '', isDefault: false };
                                }
                                _this.place.cover.source = image;
                            }
                            _this.actions.confirm(event, _this.place);
                            if (!window.location.href.includes('localhost')) {
                                var authToken = localStorage.getItem(localStorageKeys.authToken);
                                var tokenInfo = jwt_decode(authToken);
                                try {
                                    var trackName = 'editPlace - ' + _this.place.name;
                                    window['pendo'].track(trackName, {
                                        accountId: tokenInfo.userName,
                                        timestamp: Date.now(),
                                        hubName: _this.place.hubName,
                                    });
                                }
                                catch (error) {
                                    console.error(error);
                                }
                            }
                            _this.dialogRef.close();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    EditPlaceModalComponent.prototype.showChangeHistory = function () {
        var text = [];
        this.place.changeHistory.forEach(function (x, i) {
            text.push(++i + ". Changed by: " + x.userName + ", at " + new Date(x.changedAt).toLocaleString() + " ");
        });
        this.modalService.show({
            component: ShowInfoModalComponent,
            providers: [
                { provide: ShowInfoModalActions, useValue: null },
                {
                    provide: InfoModalData,
                    useValue: new InfoModalData('Result', [], text.length ? text : ['(No records)']),
                },
            ],
            panelClass: 'width-modal-3',
        });
    };
    EditPlaceModalComponent.prototype.lockInfo = function (field) {
        this.place.lock[field] = !this.place.lock[field];
    };
    EditPlaceModalComponent.prototype.businessStatusChanged = function (status) {
        console.log(status);
        if (status.value === 'CLOSED_TEMPORARILY') {
            var allSettings = LocalStorageService.getAllBackendSettingsFromLocalStorage();
            if (!allSettings)
                return;
            if (allSettings.customSettings.isKeepTempClosedPlaceInApproved === false) {
                this.alertify.warning('Set business status to "CLOSED TEMPORARILY" will set this place to unapproved status. If you want to keep it as approved, please set it under "Places" tab" in "Content Management" page.', 10);
            }
        }
        else if (status.value === 'CLOSED_PERMANENTLY') {
            this.alertify.warning('Set business status to "CLOSED PERMANENTLY" will set this place to unapproved status.', 6);
        }
    };
    EditPlaceModalComponent.prototype.generateDescription = function () {
        var _this = this;
        if (this.isGeneratingDescription)
            return;
        this.isGeneratingDescription = true;
        // this.aiGeneratedDescription = [];
        this.hubApiService
            .aiAssistant(this.place.hubName, {
            query: this.getPlaceNameAndAddress(),
            model: 'chatgpt',
            feature: 'place-description',
        })
            .finally(function () {
            _this.isGeneratingDescription = false;
        })
            .subscribe(function (data) {
            if (data.success) {
                try {
                    var json = JSON.parse(data.data);
                    _this.aiGeneratedDescription = [json.version1, json.version2, json.version3];
                    console.log(_this.aiGeneratedDescription);
                    var modal = document.querySelector('.ig-edit-place-modal');
                    modal &&
                        (modal.className = modal.className.replace('width-modal-1', 'width-modal-70p'));
                    _this.trackPlaceAIContentAssistant(_this.place);
                }
                catch (err) {
                    console.error(err);
                }
            }
        });
    };
    // public selectDescription(description) {
    //   if (this.isRegeneratingDescription) return;
    //   this.place.description = description;
    //   this.descriptionTextarea.nativeElement.classList.remove('ig-fade-in');
    //   this.descriptionTextarea.nativeElement.style.height = '130px';
    //   setTimeout(() => {
    //     this.descriptionTextarea.nativeElement.classList.add('ig-fade-in');
    //   });
    // }
    EditPlaceModalComponent.prototype.selectDescription = function (description) {
        var _this = this;
        if (this.isRegeneratingDescription)
            return;
        this.place.description = description;
        if (this.descriptionHtml) {
            this.descriptionHtml.nativeElement.classList.remove('ig-fade-in');
            this.descriptionHtml.nativeElement.style.height = '130px';
            setTimeout(function () {
                _this.descriptionHtml.nativeElement.classList.add('ig-fade-in');
            });
        }
        if (this.descriptionArea) {
            this.descriptionArea.nativeElement.classList.remove('ig-fade-in');
            this.descriptionArea.nativeElement.style.height = '130px';
            setTimeout(function () {
                _this.descriptionArea.nativeElement.classList.add('ig-fade-in');
            });
        }
        if (this.descriptionEditor) {
            this.descriptionEditor.setContents(description);
        }
    };
    Object.defineProperty(EditPlaceModalComponent.prototype, "isRegeneratingDescription", {
        get: function () {
            return this.aiGeneratedDescription.length && this.isGeneratingDescription;
        },
        enumerable: true,
        configurable: true
    });
    EditPlaceModalComponent.prototype.bulkGeneration = function () {
        var modal = document.querySelector('.ig-bulk-ai-descriptions-modal');
        if (modal) {
            modal.classList.add('ig-shake');
            setTimeout(function () {
                modal.classList.remove('ig-shake');
            }, 1000);
            return;
        }
        this.bulkAIDescriptionsStore.bulkAIDescriptionsCommand.next(this.place.hubName);
        var factory = this.componentFactoryResolver.resolveComponentFactory(BulkAIDescriptionsModalComponent);
        var componentRef = factory.create(this.injector);
        var appElement = document.querySelector('body');
        var componentRootElement = componentRef.location.nativeElement;
        appElement && appElement.appendChild(componentRootElement);
    };
    EditPlaceModalComponent.prototype.isAudioUrl = function (url) {
        var audioExtensions = ['.mp3', '.wav', '.ogg', '.aac', '.flac', '.m4a', '.mp4'];
        return audioExtensions.some(function (ext) { return url.toLowerCase().endsWith(ext); });
    };
    EditPlaceModalComponent.prototype.trackPlaceAIContentAssistant = function (place) {
        if (!window.location.href.includes('localhost')) {
            var authToken = localStorage.getItem(localStorageKeys.authToken);
            var tokenInfo = jwt_decode(authToken);
            try {
                var trackName = 'click - Place - AIContentAssistant - ' + place.name;
                window['pendo'].track(trackName, {
                    accountId: tokenInfo.userName,
                    timestamp: Date.now(),
                    hubName: place.hubName,
                });
            }
            catch (error) {
                console.error(error);
            }
        }
    };
    EditPlaceModalComponent.prototype.getPlaceNameAndAddress = function () {
        return this.place.name + ", " + (this.place.address ? this.place.address.address : '');
    };
    // private checkDoesHaveServes() {
    //   for (const serve in this.place?.dine) {
    //     if (Object.prototype.hasOwnProperty.call(this.place?.dine, serve)) {
    //       const element = this.place?.dine[serve];
    //       if (element !== null && element !== undefined) {
    //         this.hasServes = true;
    //         break;
    //       }
    //     }
    //   }
    // }
    EditPlaceModalComponent.prototype.setUpHtmlEditor = function () {
        var _this = this;
        setTimeout(function () {
            _this.descriptionEditor = window['SUNEDITOR'].create('description-editor', {
                toolbarContainer: '#toolbar_container',
                showPathLabel: false,
                charCounter: true,
                width: 'auto',
                height: 'auto',
                minHeight: '100px',
                maxHeight: '250px',
                value: _this.place.description || '',
                buttonList: [
                    ['undo', 'redo', 'font', 'fontSize', 'formatBlock'],
                    ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'removeFormat'],
                    [
                        'fontColor',
                        'hiliteColor',
                        'outdent',
                        'indent',
                        'align',
                        'horizontalRule',
                        'list',
                        'table',
                    ],
                    ['link', 'image', 'video', 'fullScreen', 'showBlocks', 'codeView', 'preview', 'print'],
                ],
            });
            _this.descriptionEditor.onImageUploadBefore = function (files, info, core, uploadHandler) {
                try {
                    _this.handleImageUploadBefore(files, info, uploadHandler);
                }
                catch (err) {
                    uploadHandler(err.toString());
                }
            };
        });
    };
    EditPlaceModalComponent.prototype.descriptionChange = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.descriptionArea && _this.descriptionArea.nativeElement) {
                _this.descriptionArea.nativeElement.style.height =
                    Math.min(_this.descriptionArea.nativeElement.scrollHeight, 300) + 'px';
            }
            if (_this.descriptionHtml) {
                _this.isDescriptionNeedShowMore = _this.descriptionHtml.nativeElement.scrollHeight > 150;
            }
        });
    };
    EditPlaceModalComponent.prototype.processImage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var image, res, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isUploadImage) return [3 /*break*/, 7];
                        if (!this.selectedImageFile) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.imageService.compressImageFileToBase64(this.selectedImageFile, config.compressImgWidth)];
                    case 1:
                        image = _a.sent();
                        if (!(image.length > 1000000)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.imageService.compressImageFileToBase64(this.selectedImageFile, config.compressImgWidth - 200)];
                    case 2:
                        image = _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.hubApiService.uploadBase64ImageToAWS(image, 960, 'places/iti-user-upload/')];
                    case 4:
                        res = _a.sent();
                        if (res.success) {
                            this.place.cover = { source: '', isDefault: false };
                            this.place.cover.source = this.imageLink = this.place.imageLink = res.url;
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        this.place.imageLink =
                            this.imageLink || (this.place.cover && this.place.cover.source) || null;
                        _a.label = 6;
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        this.place.imageLink =
                            this.imageLink || (this.place.cover && this.place.cover.source) || null;
                        if (!(this.place.imageLink && !this.place.imageLink.includes('amazonaws'))) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.hubApiService.uploadBase64ImageToAWS(this.place.imageLink, 960, 'places/iti-user-upload/')];
                    case 8:
                        res = _a.sent();
                        if (res.success) {
                            this.place.cover = { source: '', isDefault: false };
                            this.place.cover.source = this.imageLink = this.place.imageLink = res.url;
                        }
                        _a.label = 9;
                    case 9:
                        this.place.imageFile = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    EditPlaceModalComponent.prototype.processLinks = function () {
        this.place.hostLink = this.addLinkPrefix(this.place.hostLink);
        this.place.youtubeLink = this.addLinkPrefix(this.place.youtubeLink);
        this.place.facebookLink = this.addLinkPrefix(this.place.facebookLink);
        this.place.website = this.addLinkPrefix(this.place.website);
        if (this.place.audio.isActive) {
            this.place.audio.link = this.addLinkPrefix(this.place.audio.link);
        }
    };
    EditPlaceModalComponent.prototype.addLinkPrefix = function (link) {
        var linkWithPrefix = link ? (link.startsWith('http') ? link : "https://" + link) : '';
        return linkWithPrefix;
    };
    EditPlaceModalComponent.prototype.processCategory = function (event) {
        if (this.place.socialName === 'google') {
            /**
             * google place's category is in snake case (e.g., point_of_interests),
             * while imgoing place category display text in place cards and edit popup is like "Point of Interests", and separated by "," when saving to database
             */
            if (this.place.categoryText) {
                var cateSeg = this.place.categoryText.split(',').map(function (x) { return x.trim(); });
                cateSeg = cateSeg.map(function (x) {
                    x = x.replace(/( )+/g, '_');
                    x = x.toLowerCase();
                    return x;
                });
                cateSeg = cateSeg.filter(function (x) { return !!x; });
                this.place.categoryList = cateSeg;
                this.place.category = cateSeg.join(', ');
                this.place.categoryText = cateSeg
                    .map(function (x) { return x.replace(/(_)+/g, ' ').upperFirstLetter(); })
                    .join(', ');
            }
            else {
                this.alertify.warning('Please specify a category.');
                event.complete();
                return false;
            }
        }
        else if (!this.place.category) {
            this.alertify.warning('Please specify a category.');
            event.complete();
            return false;
        }
        return true;
    };
    EditPlaceModalComponent.prototype.createForm = function () {
        this.createPlaceForm = this.formBuilder.group({
            name: [null, [Validators.required]],
            description: [null, []],
            timeRanges: this.formBuilder.array([]),
            address: [null, [Validators.required]],
            category: [null, []],
            categoryText: [null, []],
            subCategory: [null, []],
            ticketUri: [null, []],
            facebookEvent: [null, []],
            hostLink: [null, []],
            eventLink: [null, []],
            website: [null, []],
            imageLink: [null, []],
            phone: [null, []],
            email: [null, [Validators.pattern(config.emailPattern)]],
            priceRange: [null, []],
            timezone: [null, []],
            _360VideoKey: [null, []],
            youtubeLink: [null, []],
            facebookLink: [null, []],
            ownerEmail: [null, []],
            ownerPhone: [null, []],
            business_status: [null, []],
            audio_link: [null, []],
            audio_description: [null, []],
            audio_is_active: [null, []],
        });
    };
    EditPlaceModalComponent.prototype.handleImageUploadBefore = function (files, info, uploadHandler) {
        var _this = this;
        this.imageService
            .getBase64ByImageFile(files[0])
            .then(function (imageInfo) {
            if (imageInfo) {
                _this.hubApiService
                    .uploadBase64ImageToAWS(imageInfo)
                    .then(function (res) {
                    if (res.success) {
                        var response = {
                            result: [
                                {
                                    url: "" + res.url,
                                    name: files[0].name,
                                    size: files[0].size,
                                },
                            ],
                        };
                        uploadHandler(response);
                    }
                    else {
                        uploadHandler('upload image fail');
                    }
                })
                    .catch(function (err) {
                    uploadHandler('upload image fail');
                    console.error(err);
                });
            }
        })
            .catch(function (err) {
            console.error(err);
        });
    };
    return EditPlaceModalComponent;
}(BaseComponent));
export { EditPlaceModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.place.modal/edit.place.modal.component.ts.pre-build-optimizer.js